var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitment9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.855,
    height: 82.676,
    viewBox: "0 0 90.855 82.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172483",
    "data-name": "\\uADF8\\uB8F9 172483",
    transform: "translate(60.293 -2.535) rotate(60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121619",
    "data-name": "\\uD328\\uC2A4 121619",
    d: "M3461.257,2289.786c-6.507,7.622-30.86,23.424-30.86,23.424s21.751,11.34,23.424,40.341c19.892-9.109,34.764-18.033,34.764-18.033S3489.887,2313.024,3461.257,2289.786Z",
    transform: "translate(-3430.397 -2283.931)",
    fill: "#6b6b6b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121620",
    "data-name": "\\uD328\\uC2A4 121620",
    d: "M3475.551,2261.2c-6.506,7.622-30.86,23.424-30.86,23.424s21.751,11.34,23.424,40.342c19.892-9.109,34.764-18.033,34.764-18.033S3504.181,2284.435,3475.551,2261.2Z",
    transform: "translate(-3441.764 -2261.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121621",
    "data-name": "\\uD328\\uC2A4 121621",
    d: "M3517.643,2301.227q-5.624,4.052-11.219,8.145c-1.846,1.35-3.679,2.717-5.515,4.08a54.2,54.2,0,0,0-5.356,4.187.284.284,0,0,0,.343.444,54.469,54.469,0,0,0,5.652-3.847c1.856-1.331,3.714-2.659,5.561-4q5.543-4.038,11.058-8.113C3518.694,2301.731,3518.188,2300.835,3517.643,2301.227Z",
    transform: "translate(-3482.141 -2292.952)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121622",
    "data-name": "\\uD328\\uC2A4 121622",
    d: "M3535.914,2327.279c-3.77,2.456-7.5,4.983-11.234,7.489-1.848,1.24-3.686,2.494-5.529,3.742-.943.638-1.892,1.268-2.826,1.92a14.966,14.966,0,0,0-2.538,1.935c-.17.185-.007.553.264.454a14.786,14.786,0,0,0,2.743-1.586c.958-.613,1.9-1.249,2.852-1.875,1.856-1.225,3.716-2.443,5.567-3.677,3.745-2.5,7.5-4.975,11.216-7.52C3536.966,2327.793,3536.47,2326.917,3535.914,2327.279Z",
    transform: "translate(-3496.655 -2313.678)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121623",
    "data-name": "\\uD328\\uC2A4 121623",
    d: "M3555.054,2350.03q-5.755,3.724-11.492,7.472-2.873,1.871-5.735,3.755c-.911.6-1.825,1.2-2.728,1.808a13.73,13.73,0,0,0-2.655,2.056c-.154.173-.008.492.239.411a12.918,12.918,0,0,0,2.8-1.5c.968-.606,1.926-1.228,2.885-1.847q2.878-1.86,5.749-3.731,5.74-3.747,11.475-7.5C3556.169,2350.579,3555.636,2349.653,3555.054,2350.03Z",
    transform: "translate(-3511.495 -2331.768)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121624",
    "data-name": "\\uD328\\uC2A4 121624",
    d: "M3568.567,2383.007c-.216.041-.424-.061-.634-.007a3.682,3.682,0,0,0-.681.343q-.829.432-1.657.866-1.585.835-3.169,1.674l-6.475,3.421q-3.168,1.674-6.33,3.36a34.872,34.872,0,0,0-6.207,3.666c-.147.125.011.36.182.313a34.127,34.127,0,0,0,6.416-3q3.25-1.687,6.486-3.4l6.341-3.342q1.654-.872,3.308-1.744c.551-.291,1.1-.586,1.65-.879a2.864,2.864,0,0,0,.6-.335c.173-.163.214-.378.387-.551A.23.23,0,0,0,3568.567,2383.007Z",
    transform: "translate(-3520.223 -2358.043)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121625",
    "data-name": "\\uD328\\uC2A4 121625",
    d: "M3591.123,2414.86c-3.967,2.008-7.849,4.2-11.767,6.3q-2.872,1.541-5.739,3.093a37.762,37.762,0,0,0-5.7,3.292c-.216.172.018.533.264.454a36.782,36.782,0,0,0,5.773-2.866q2.945-1.57,5.89-3.142c3.919-2.1,7.9-4.119,11.763-6.311C3592.143,2415.379,3591.668,2414.583,3591.123,2414.86Z",
    transform: "translate(-3539.685 -2383.345)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121626",
    "data-name": "\\uD328\\uC2A4 121626",
    d: "M3607.583,2450.808q-5.807,3.092-11.61,6.192c-1.887,1.01-3.781,2.01-5.66,3.033-.962.524-1.93,1.041-2.884,1.581a11.637,11.637,0,0,0-2.67,1.732.193.193,0,0,0,.186.319,11.366,11.366,0,0,0,2.806-1.19c.984-.486,1.952-1,2.926-1.507,1.947-1.009,3.88-2.047,5.819-3.072q5.817-3.076,11.624-6.168C3608.726,2451.406,3608.189,2450.486,3607.583,2450.808Z",
    transform: "translate(-3553.103 -2411.924)",
    fill: "#303030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment9);
export default __webpack_public_path__ + "static/media/recruitment9.6a22a3b468c278e6479642de4b0247ac.svg";
export { ForwardRef as ReactComponent };